<template>
  <el-tooltip :content="$t('inspector_teams.leave.btnTooltip')"
              effect="light"
              :open-delay="300"
              placement="bottom">
    <base-button block type="warning" class="m-0" @click.native="handleLeaveInspectorTeam()" :loading="updating">
      {{ $t('inspector_teams.leave.btnLbl') }}
    </base-button>
  </el-tooltip>
</template>

<script>
  import {mapActions, mapState} from "vuex";
  import swal from "sweetalert2";

  export default {
    name: "LeaveInspectorTeamBtn",
    props: {
      details: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapState({
        updating: state => state.inspector_teams.updating,
        error: state => state.inspector_teams.error,
      }),
    },
    methods: {
      ...mapActions(['LeaveInspectorTeam', 'LoadInspectorTeamMembers']),
      handleLeaveInspectorTeam() {
        swal({
          title: this.$t('inspector_teams.leave.text'),
          text: `'${this.details.name}'`,
          confirmButtonText: this.$t('inspector_teams.leave.actionBtnLabel'),
          cancelButtonText: this.$t('inspector_teams.leave.cancelBtnLabel'),
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary',
          cancelButtonClass: 'btn btn-secondary',
          type: 'question',
          showCancelButton: true
        }).then(result => {
          if (result.value) {
            this.LeaveInspectorTeam(this.details.id).then(() => {
              if (this.error == null) {
                // Refresh token and user data after joining inspector team.
                this.$auth.refresh();
                this.$auth.fetch();

                this.$notify({
                  type: 'success',
                  message: this.$t('inspector_teams.leave.joinedNotification', {
                    name: this.details.name
                  }),
                  icon: 'tim-icons icon-alert-circle-exc'
                })
                this.LoadInspectorTeamMembers(this.details.id)
              }

            })
          }
        });
      },
    }
  }
</script>

<style scoped>

</style>
